module.exports = __webpack_public_path__ + "img/apoio-dbbyf.84ff1200.png";